import React, { useEffect } from 'react';
import { WorkflowModes, WorkflowModesID } from '../../__generated__/constants';
import { DSPHasuraJWT } from 'src/products/shell/DSPRelayEnvironment/jwt';
import { parseTokenWorkflowModes } from '.';
import { usePermission } from 'src/hooks';
import { useSelector } from 'react-redux';

export const DSPModeContext = React.createContext<
  [WorkflowModesID, (mode: WorkflowModesID) => void] | undefined
>(undefined);

export const DspDevModeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const userProfile = useSelector((s) => s?.user?.profile?.value);

  const dspPermissions = usePermission([
    'DSPAdmin',
    'DSPEmulateUser',
    'DSPRegular',
    'DSPUserManagement',
  ]);

  const defaultMode = WorkflowModes.PRODUCTION.id;

  const [devMode, setDevMode] = React.useState<WorkflowModesID | null>(null);

  useEffect(() => {
    if (devMode) {
      return;
    }

    if (__TEST__) {
      setDevMode(WorkflowModes.PRODUCTION.id);
      return;
    }

    if (!userProfile) {
      return;
    }

    if (!dspPermissions && userProfile) {
      setDevMode(WorkflowModes.PRODUCTION.id);
      return;
    }

    (async () => {
      const jwtTokenClient = DSPHasuraJWT.getInstance();
      jwtTokenClient.setMode(defaultMode);
      await jwtTokenClient.queueFetchHasuraToken();
      const token = DSPHasuraJWT.getInstance().getDecodedToken();
      const tokenMode = parseTokenWorkflowModes(token)[0];
      setDevMode(tokenMode ?? defaultMode);
    })();
  }, [devMode, dspPermissions, userProfile]);

  if (!devMode) {
    return null;
  }

  if (dspPermissions && !__TEST__) {
    DSPHasuraJWT.getInstance().setMode(devMode);
  }

  return (
    <DSPModeContext.Provider value={[devMode, setDevMode]}>
      {children}
    </DSPModeContext.Provider>
  );
};
